var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHydrogenOne(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 61 61",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "hydrogenOne"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30.313,
    cy: 30.126,
    r: 29.946,
    style: {
      fill: "#4888ad"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.193,8.945c0,0 10.283,8.784 13.229,13.289c6.982,10.678 -1.167,24.249 -12.218,24.652c-10.993,0.401 -22.438,-10.841 -13.224,-25.279c2.125,-3.331 12.213,-12.662 12.213,-12.662Z",
    style: {
      fill: "#fff",
      stroke: "#4888ad",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.17,23.392l-0.147,15.004m10.42,-15.004l-0.148,15.004m0,-8.302l-10.125,-0",
    style: {
      fill: "#4888ad",
      stroke: "#4888ad",
      strokeWidth: 2
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHydrogenOne);
export default __webpack_public_path__ + "static/media/hydrogenOne.dbecb6e6e6d483018d28e2a986368ee9.svg";
export { ForwardRef as ReactComponent };